import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from './actions';
import _ from 'lodash';
import scrollIntoView from 'scroll-into-view';

let ListOption = class ListOption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.truncLength = 4;
    this.countForOption = this.countForOption.bind(this);
  }

  componentWillMount() {
    if (!this.props.values) return;
    this.uniqValues = _.uniq(this.props.values.map(item => item.toLowerCase()));
  }

  componentWillReceiveProps(props) {
    if (!props.values) return;
    this.values = null;
    this.uniqValues = _.uniq(props.values.map(item => item.toLowerCase()));
  }

  componentDidMount() {
    this.parentContainer = document.querySelector(this.props.parentSelector);
  }

  render() {
    if (this.state.more) this.values = this.uniqValues;
    else this.values = this.uniqValues.slice(0, this.truncLength);
    return (
      <ul className="filter-option-list">
        {this.values.map(value => (
          <li
            className={
              'filter-option-item' + (this.isSelected(value) ? ' selected' : '')
            }
            key={value}
            onClick={this.toggle.bind(this, value)}
          >
            <i className="filter-option-item-toggle" />
            <span className="filter-option-item-value">
              {`${value.toLowerCase()} (${this.countForOption(value)})`}
            </span>
          </li>
        ))}
        {this.uniqValues.length > this.truncLength && (
          <Fragment>
            {!this.state.more ? (
              <li className="filter-option-item">
                <span
                  className="filter-option-more"
                  onClick={this.more.bind(this, true)}
                >
                  View More
                </span>
              </li>
            ) : (
              <li className="filter-option-item">
                <span
                  className="filter-option-more"
                  onClick={this.more.bind(this, false)}
                >
                  View Less
                </span>
              </li>
            )}
          </Fragment>
        )}
      </ul>
    );
  }

  more(show) {
    this.setState({ more: show });
  }

  isSelected(value) {
    let selected = this.props.selected[this.props.name] || [];
    return selected == value || selected.indexOf(value) != -1;
  }

  countForOption(value) {
    return this.props.aggs[value];
  }

  toggle(value) {
    value = value.toLowerCase();
    let selected = this.props.selected[this.props.name] || [];
    if (!_.isArray(selected)) selected = [selected];
    const isSelected = this.isSelected(value);
    if (isSelected) selected = _.without(selected, value);
    else selected.push(value);

    let result = { ...this.props.selected, skip: 0 };
    if (_.isEmpty(selected)) delete result[this.props.name];
    else result[this.props.name] = selected;

    this.props.selectFilters(result);
    this.props.history.replace(
      actions.pathForSelected(this.props.location, result)
    );

    if (!isSelected) {
      scrollIntoView(this.parentContainer, {
        time: 300,
        align: { top: 0, topOffset: 120 }
      });
    }
  }
};

function mapStateToProps(state) {
  return { selected: state.filter.selected };
}

export default connect(mapStateToProps, { ...actions })(withRouter(ListOption));
export { ListOption };



// WEBPACK FOOTER //
// ./shared/components/filter/listOption.js